import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Divider,
    ListItemText,
    Button,
    Box,
    Link,
    Drawer,
    IconButton,
    List,
    ListItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import { fadeInUp } from '../../utils/animations';

const StickyNotificationBar = () => {
    const [isVisible, setIsVisible] = useState(true); // State to control visibility

    const handleClose = () => {
        setIsVisible(false); // Hide the box when the close button is clicked
    };

    if (!isVisible) return null; // Don't render the box if it's hidden

    return (
        <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            style={{
                position: "sticky", // Make the motion.div sticky
                top: 0, // Stick to the top
                zIndex: 1000, // Ensure it stays above other content
            }}
        >
            <Box
                style={{
                    backgroundColor: "#121212",
                    color: "#fff",
                    height: "60px",
                    display: "flex",
                    justifyContent: "space-between", // Space between text and close button
                    alignItems: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "100%", // Full width
                    padding: "0 16px", // Add padding for spacing
                }}
            >
                <Box>Launch dates for the Get Sorted app will be released soon.</Box>
                <IconButton
                    onClick={handleClose}
                    style={{
                        color: "#fff",
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </motion.div>
    );
};
export default StickyNotificationBar;